import React from "react";
import { Navbar, Nav, NavItem, MenuItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Utils from "../../../lib/utils";
import { styles, StyledNavbar, Container, Dropdown, Logo } from "./style.ts";
import logo from "../../../images/logo.png";

const EmployerNav = ({ user, logOut, DropdownButton }) => (
  <Container>
    <StyledNavbar style={styles.container} fixedTop className="header">
      <Logo>
        <Navbar.Header>
          <Navbar.Brand>
            <Link style={styles.logo} to="/">
              <img src={logo} alt="QuirkyCoders" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle id="nav-toggle" style={styles.toggle} />
        </Navbar.Header>
      </Logo>
      <Navbar.Collapse>
        <Nav>
          {Utils.isSignedIn() && (
            <LinkContainer to="/dashboard">
              <NavItem style={styles.link}>Dashboard</NavItem>
            </LinkContainer>
          )}
          {Utils.isSignedIn() && user && user.id === 11 && (
            <Nav>
              <LinkContainer to="/admin/analytics">
                <NavItem style={styles.link}>Analytics</NavItem>
              </LinkContainer>
            </Nav>
          )}
          <LinkContainer to="/products">
            <NavItem style={styles.link}>Products</NavItem>
          </LinkContainer>
          {!Utils.isSignedIn() && (
            <LinkContainer to="/employers/contact-us">
              <NavItem style={styles.link}>Contact Us</NavItem>
            </LinkContainer>
          )}
        </Nav>
        <Nav pullRight>
          <LinkContainer to="/profiles">
            <NavItem style={styles.link}>Find a Candidate</NavItem>
          </LinkContainer>
          {Utils.isSignedIn() && (
            <LinkContainer to="/employers/post-job">
              <NavItem style={styles.link}>Post Jobs</NavItem>
            </LinkContainer>
          )}
          {!Utils.isSignedIn() && (
            <LinkContainer to="/employers">
              <NavItem style={styles.link}>Post Jobs</NavItem>
            </LinkContainer>
          )}
          {Utils.isSignedIn() && (
            <Dropdown id="dropdown" title={DropdownButton(user)}>
              <LinkContainer to="/dashboard/jobs">
                <MenuItem>Jobs</MenuItem>
              </LinkContainer>
              <LinkContainer to="/dashboard/candidates">
                <MenuItem>Candidates</MenuItem>
              </LinkContainer>
              <LinkContainer to="/dashboard/settings">
                <MenuItem>Settings</MenuItem>
              </LinkContainer>
              <LinkContainer to="/dashboard/help">
                <MenuItem>Help</MenuItem>
              </LinkContainer>
              <MenuItem onClick={logOut}>Logout</MenuItem>
            </Dropdown>
          )}
          {!Utils.isSignedIn() && (
            <LinkContainer to="/login">
              <NavItem style={styles.link}>Signin / Register</NavItem>
            </LinkContainer>
          )}
        </Nav>
      </Navbar.Collapse>
    </StyledNavbar>
  </Container>
);

export default EmployerNav;
